import { Component } from '@angular/core';
import {
  CcdlDividerComponent,
  CcdlLinkComponent,
} from '@cpm-pr1618001/ng-design-lib';

@Component({
  selector: 'terms-of-use',
  imports: [CcdlDividerComponent, CcdlLinkComponent],
  templateUrl: './terms-of-use.component.html',
  styleUrl: './terms-of-use.component.scss',
})
export class TermsOfUseComponent {}
